<template v-slot:body="props">
  <q-dialog v-model="downloadFolderReport" class="share-grants-page">
    <q-card class="share-dialog">
      <q-card-section>
        <div class="text-h5 text-main bold-font">
          {{
            t("share_and_download_schemes.download_selected_items_as_a_report")
          }}
        </div>
      </q-card-section>
      <q-card-section>
        <div class="row justify-between top-section-responsive">
          <div class="column column-width">
            <span class="input-heading">
              {{ t("share_and_download_schemes.report_title") }} *
            </span>
            <q-input
              class="q-mt-sm bg-white"
              v-model="reportTitle"
              dense
              :rules="requiredFieldRule"
            />

            <span class="input-heading q-mt-md">
              {{ t("share_and_download_schemes.description") }}
            </span>
            <q-input
              class="q-mt-sm bg-white"
              v-model="description"
              type="textarea"
            />
          </div>
        </div>
      </q-card-section>

      <q-card-section class="report-type">
        <q-select
          square
          v-model="reportType"
          :options="reportOptions"
          option-label="description"
          option-value="id"
          emit-value
          map-options
          :label="t('share_and_download_schemes.type_of_report')"
          style="width: 47%"
          class="bg-white"
        />
      </q-card-section>

      <q-card-actions class="q-mt-sm" align="left">
        <q-btn
          flat
          no-caps
          :label="t('search_schemes.download')"
          class="orange-btn-filled"
          color="white"
          @click="
            generateFolderReport(
              reportTitle,
              description,
              customerName,
              reportType
            )
          "
        />
        <q-btn
          no-caps
          flat
          :label="t('common.cancel')"
          class="orange-btn-cancel"
          v-close-popup
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { computed, ref } from "vue";
import store from "../../store/index";
import { useI18n } from "vue-i18n";
import grantsService from "../../services/grants.service";

export default {
  setup() {
    const { t, locale } = useI18n();
    const getFolderToDownload = computed({
      get: () => store.state.grantItems.folderToDownload,
    });

    const reportTitle = computed({
      get: () => store.state.grantItems.nameOfDownloadFolder,
      set: (value) => store.commit("grantItems/nameOfDownloadFolder", value),
    });

    const downloadFolderReport = computed({
      get: () => store.state.grantItems.downloadFolderReport,
      set: (val) => store.commit("grantItems/disableDownloadFolderReport", val),
    });
    const disableDownloadFolderReport = () => {
      store.commit("grantItems/disableDownloadFolderReport");
    };

    const generateFolderReport = async (
      reportTitle,
      description,
      customerName,
      reportType
    ) => {
      if (!reportTitle) return;

      // build the payload
      const formData = new FormData();
      formData.append("reportType", reportType);
      formData.append("reportTitle", reportTitle);
      formData.append("reportDescription", description);
      formData.append("customerName", customerName);

      // include folderId & culture in the query string
      const folderId = getFolderToDownload.value;
      const culture = locale.value;
      const url = `../api/download/generateFolderReport?folderId=${encodeURIComponent(
        folderId
      )}&culture=${encodeURIComponent(culture)}`;

      try {
        await grantsService.postFormAndDownload(url, formData);
      } catch (err) {
        console.error("Folder report download failed:", err);
        // TODO: show user‐friendly error
      } finally {
        store.commit("grantItems/disableDownloadFolderReport");
      }
    };

    const description = ref("");
    const customerName = ref("");

    const isVind = computed({
      get: () => store.state.auth.env === 0 || store.state.auth.env === 40,
    });
    const authUser = computed({
      get: () => store.state.auth.authUser,
    });

    const reportOptions = computed({
      get: () => store.state.mailing.reportTypesList,
    });
    const reportType = ref(0);

    return {
      reportOptions,
      reportType,
      t,
      locale,
      downloadFolderReport,
      disableDownloadFolderReport,
      generateFolderReport,
      getFolderToDownload,
      options: reportOptions.value,
      isVind,
      authUser,
      customerName,
      description,
      reportTitle,
      requiredFieldRule: [
        (val) => (val && val.length > 0) || t("common.required_field"),
      ],
      isValidEmail(val) {
        const emailPattern =
          /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
        return emailPattern.test(val) || t("common.invalid_email_address");
      },
    };
  },
};
</script>
